import axios from "axios";

const ActiveGw = async () => {
  try {
    const active_gw = await axios.get(
      "https://api.palinagyonbuzi.com/api/giveaway/active",
      {
        headers: {
          Authorization: "Bearer f2414060-927a-411b-a481-197241e5828d",
        },
      },
    );
    if (active_gw.data && active_gw.data[0] && active_gw.data[0].participants) {
      const kw = active_gw.data[0].keyword;
      const created_at = active_gw.data[0].createdAt;
      const users = active_gw.data[0].participants.map((element) => ({
        id: element.discord_id,
        name: element.twitch_name,
        avatar: element.image,
        isMod: element.isMod,
        isVip: element.isVip,
        boostTickets: element.boostTickets ?? 0,
      }));
      return { users, kw, created_at };
    } else {
      let users,
        kw = null;
      return { users, kw };
    }
  } catch (error) {
    console.error("Error fetching giveaway profiles:", error);
    return { users: null, kw: null };
  }
};

export default ActiveGw;
